import { Paper, Typography } from '@mui/material';

import styled from 'styled-components';

export const StyledEntitlements = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

export default StyledEntitlements;

export const Title = styled(Typography)`
	font-style: normal;
	font-weight: 400;
	font-size: 24px;
	line-height: 32px;
	margin-top: 15px;
	color: #252f33;
	padding: 5px 0px 5px 0px;
`;

export const PaperStyled = styled(Paper)`
	display: flex;
	flex-direction: column;
	margin-top: 30px;
`;
